import styled from 'styled-components'
import colors from './../../styles/colors'
import { devicesMax } from './../../styles/breakpoints'

import border from './../../../img/scroll-border.png'
import dots from './../../../img/scroll-dots.png'
import { TextArea } from '../formElements'

export const StyledDecorativeTextArea = styled.div`
  display: inline-block;
  color: ${colors.red};

  position: relative;

  max-width: 100%;
  width: 800px;

  padding: 5rem 4rem;
  margin: 1rem 0;

  border: solid;
  border-image: url(${border});
  border-image-slice: 149;
  border-image-width: 100px;

  @media ${devicesMax.mobile.lg} {
    border-image-width: 50px;
    padding: 2.5rem 2rem;
  }

  ::before,
  ::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    width: 35px;
    height: 100%;

    background-image: url(${dots});
    background-size: 10px auto;
    background-repeat: no-repeat;
    background-position: center;

    @media ${devicesMax.mobile.lg} {
      width: 15px;
      background-size: 5px auto;
    }
  }

  ::before {
    left: 0;
  }

  ::after {
    right: 0;
  }
`

export const StyledTextArea = styled(TextArea)`
  background: none;
  outline: none;
  border: none;

  width: 100%;
  padding: 0.5rem;

  line-height: 2rem;

  background-image: linear-gradient(transparent, transparent calc(2rem - 1px), ${colors.red} 37px);
  background-size: 100% 2rem;

  color: ${colors.red};
  font-style: italic;

  ::placeholder {
    color: ${colors.red};
    opacity: 0.5;
  }
`
